// extracted by mini-css-extract-plugin
export default {"heading":"DepositList_heading__e-Zbr","list":"DepositList_list__rGakw","container":"DepositList_container__HgQWc"};